import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICONS_CODEPOINTS } from '../../../../../styles/icons';
import sortBy from 'lodash-es/sortBy';

/**
 * Grid size options list
 */
export const gridSizeOptions: NICmsContentField.IOption[] = [
    { key: 12, title: '1' },
    { key: 6, title: '2' },
    { key: 4, title: '3' },
    { key: 3, title: '4' },
    { key: 2, title: '6' },
    { key: 1, title: '12' }
];

const icons = sortBy(
    Object.keys(ICONS_CODEPOINTS).map(iconKey => {
        return {
            key: `icon-${iconKey}`,
            title: iconKey
        };
    }),
    i => i.title
);

export const iconsOptions: NICmsContentField.IOption[] = [...UndefinedOption, ...icons];
